import {
  EnumBooleanStringifiedExtended,
  EnumCurrency,
  EnumPlayerFormat,
  ICurrencyDescription,
  IEmoji,
  IReaction,
  JSONString,
} from "../@types";
import { IGift } from "./gifts";
import { IBACKENDPAYLOAD } from "./backend";
import { ACTION } from "./command/action";
import { baseParamsType, SupportedLanguage } from "./command/baseparams";
import { ICOMMAND, IKeyMaybeValue, IKeyValue, IRESPONSE, RESULT } from "./command/icommand";
import { SChatInfo } from "./live/livechat";
import { ChatState } from "./chatstate";
import { ComaSeparatedValues } from "./sessionstate";
import { clientID } from "./clivechat";
import { EnumInitDataFormat } from "../cmd-connection";

export interface IInitBackendPayload {
  giftBundles: any;
  giftCategories: any;
  gifts: any;
  emoticons: any;
  currency: any;
  toyControls: any;
  icons: any;
}

export type UploadMediaTus = {
  authHeader: string;
  /**
   * @deprecated/obsolete
   */
  chunkSize?: number;
  chunksNumber: number;
  endPoint: string;
  maxChunkSize: number;
  minChunkSize: number;
  parallelUploads: number;
};

/**
 * the initial command
 */
export class CMDP_INIT implements ICOMMAND {
  public action: ACTION = ACTION.CMDP_INIT;
  public params: baseParamsType & {
    login?: string;
    initData?: EnumInitDataFormat;
  };
}

/**
 * Response for CMDP_INIT
 */
export class CMDP_INIT_RESPONSE extends CMDP_INIT implements IRESPONSE, IBACKENDPAYLOAD {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: {
    /** minimal version info */
    versionRequired?: string;
    /** version last */
    versionLast?: string;
    /** update url */
    versionUpdateUrl?: string;
    /** where to send message media */
    uploadMediaUrl?: string;
    speedTestUrl?: string;
    gtcUrl?: string;
    uploadFeedbackUrl?: string;
    translations?: JSONString<InitialTranslations>;
    gifts?: JSONString<IGift[]>;
    emojiList?: JSONString<IEmoji[]>;
    currency?: JSONString<InitialCurrencies>;
    currencyFormat?: JSONString<InitialCurrencies>;
    vxc_factor?: string;
    reactions?: JSONString<IReaction[]>;
    passwordResetUrl?: string;
    registrationUrl?: string;
  };
  /** backendpayload */
  public payload?: IInitBackendPayload;
}

export type InitialTranslations = {
  [key in SupportedLanguage]?: IKeyValue;
};

export type InitialCurrencies = {
  [key in EnumCurrency]?: ICurrencyDescription;
};

/**
 * the initial command, 8320 only
 */
export class CMDP_SINIT extends CMDP_INIT {
  public action: ACTION = ACTION.CMDP_SINIT;
}

/** Response for CMDP_SINIT, 8320 only */
export class CMDP_SINIT_RESPONSE extends CMDP_INIT_RESPONSE {
  public action: ACTION = ACTION.CMDP_SINIT;
}

/**
 * the initial chat command
 */
export class CMDP_CINIT implements ICOMMAND {
  public action = ACTION.CMDP_CINIT;
  public params: clientID & {
    version: string;
    initData: EnumInitDataFormat;
    messengerProperties: string;
  };
}

/**
 * Response for CMDP_CINIT
 */
export class CMDP_CINIT_RESPONSE extends CMDP_CINIT implements IRESPONSE {
  public result: RESULT;
  public commands: ICOMMAND[];
  public values: Omit<SChatInfo & ChatState, "chatID" | "type" | "startTime"> & {
    chatId: string;
    hostId: string;
    hostlogin: string;
    introVideoHls?: string;
    rechargeWarningThres?: string;
    rollbarKey?: string;
    server?: string;
    singlePrice?: string;
    timeStamp: string;
    fsk16?: EnumBooleanStringifiedExtended;
    /** where to send message media */
    uploadMediaUrl?: string;
    uploadFeedbackUrl?: string;
    formatsIncluded?: ComaSeparatedValues<EnumPlayerFormat>;
    formatsExcluded?: ComaSeparatedValues<EnumPlayerFormat>;
    translations?: JSONString<InitialTranslations>;
    emojiList?: JSONString<IEmoji[]>;
    currency: EnumCurrency;
    currencyFormat?: JSONString<InitialCurrencies>;
    reactions?: JSONString<IReaction[]>;
    publicUsers?: JSONString<{ userName: string }[]>;
    vxc_factor?: string;
  } & IKeyMaybeValue;
}
